import { color } from "chart.js/helpers";
import NumeroTicket from "./NumeroTicket";

const styles = {
    ticketContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
        color: "white",
    },
};

function Ticket({ numero, personasAntes }) {
    return (
      <div className="p-1" style={styles.ticketContainer}>
        <h1 className="fs-1 fw-bold">Tu número es el:</h1>
        <NumeroTicket numero={numero} />
        <p className="fs-2">
            {personasAntes == null
                ? "Tu turno ya no está activo."
                : personasAntes === 0
                ? "¡Prepárate! Tu turno será el siguiente. Mantente atento al llamado."
            : `Hay ${personasAntes} persona${
                personasAntes > 1 ? "s" : ""
            } antes de ti`}
        </p>
      </div>
    );
}

export default Ticket;
